module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10047.2b304e67.jpg";